const langs = {
    zh: {
        companyName: "江苏米山科技有限公司",
        companyName2: "江苏米山复合材料有限公司",
        companyName_short: "江苏米山",
        companyDesc: "专业从事高端绿色汽车内饰材料生产的新兴技术企业，旨为中高档汽车、新能源汽车提供更环保、更舒适、更高品质的内饰材料。",
        telephone: "24小时服务热线",
        nav_home: "官网首页",
        nav_about: "关于我们",
        nav_products: "产品&解决方案",
        nav_technology: "技术创新",
        nav_news: "新闻资讯",
        nav_contact: "联系我们",
        lang_zh: "中文版",
        lang_en: "English",
        lang_ja: "日本語版",
        address: "江苏省泰州市医药高新区（高港区）永平路232号许庄双创产业园二期7号厂房",
        advantage1: "低气味与低VOC",
        advantage1_desc: "我们的复合工艺由于不需要燃烧海绵，所以不会产生海绵燃烧所带来的灼烧气味和额外超量的VOC，以及对环境污染的问题就大大的得到了降低。",
        advantage2: "减少海绵黄化和卷曲",
        advantage2_desc: "高温的生产氛围会对海绵的结构和性质造成破坏性影响，较常发生的情况就是海绵黄化和材料卷曲的情况，胶水复合由于其低温覆合特性，能显著减少海绵黄化问题的产生。另外，由于胶面厚度仅为0.05mm/㎡，几乎不影响材料本身的延展性，保持了材料本身柔软舒适的特点。",
        advantage3: "保护好表皮材料表面",
        advantage3_desc: "由于是低温复合，复合时温度在30℃-50℃之间，对表皮的表面不会造成伤害，热熔胶是透明色，对浅色表皮的表面不会造成颜色的污染。",
        advantage4: "可控的产品厚度",
        advantage4_desc: "我们复合是涂胶的厚度为0.03~0.05毫米，不需要燃烧海绵，因此能很好的控制总成复合产品的厚度。",
        advantage5: "不增加成本",
        advantage5_desc: "火焰复合燃烧掉的海绵正好是我们滚涂在海绵上的热熔胶，而且我们根据不同的材料，可以控制不同的胶量，既能达到剥离力的要求，同时还能够控制成本。因此我们能够做到与火焰复合更低的成本。",
        advantage6: "更广的应用",
        advantage6_desc: "我们能够复合3D mesh ,PP foam ,织物，真皮等不能燃烧及对复合强度有很高要求材料。",
        title_about: "关于米山",
        about_desc1: "<strong>江苏米山</strong>是专业从事高端绿色汽车内饰材料生产的新兴技术企业，旨为中高档汽车、新能源汽车提供更环保、更舒适、更高品质的内饰材料。",
        about_desc2: "采用现在先进的环保复合技术，使用环保的高分子粘合技术来进行汽车内饰产品的低温复合，摈弃传统火焰复合工艺。带来更环保、更高端、触感更舒适的环保轻质化汽车内饰产品。",
        about_desc3: "<strong>江苏米山</strong>提供真皮、人造革、发泡材料等汽车内饰面料的复合、裁切、缝纫、预涂胶、包装等全方位的定制化配套业务。",
        about_desc4: "<strong>江苏米山</strong>成功通过了IATF16949:2016国际汽车行业质量管理体系认证，以更高的质量管理理念，更专业的管理团队，更优秀的设备及生产技术，为您提供更满意的产品和服务。",
        product_feature_car: "<strong>江苏米山</strong>采用现在先进的环保复合技术，使用环保的高分子粘合技术来进行汽车内饰产品的低温复合，摈弃传统火焰复合工艺。带来更环保、更高端、触感更舒适的环保轻质化汽车内饰产品。",
        product_feature_other: "<strong>江苏米山</strong>采用现在先进的环保复合技术，使用环保的高分子粘合技术来进行产品的低温复合，带来环保性能更高、稳定性更好的复合产品。",
        btn_view_products: "查看产品",
        btn_view_more: "继续浏览",
        about_right_title1: "资深国际市场运营团队",
        about_right_txt1: "拥有一支业内资深专家组成的国际市场运营团队，具备国际化的前瞻视野",
        about_right_title2: "全球化市场营销",
        about_right_txt2: "产品远销欧洲、美国、德国、日本等区域，并处在持续扩张中",
        about_right_title3: "产品优质，价格实惠",
        about_right_txt3: "高端绿色产品，不断创新，为客户提供优质的产品",
        title_advantages: "我们的优势",
        title_products: "产品&服务",
        span_address: "地址",
        span_address2: "公司地址",
        span_mobile: "联系方式",
        span_email: "邮箱",
        span_campany: "公司信息",
        span_news_detail: "新闻详情",
        nav_campany_news: "公司新闻",
        title_company_intro: "企业介绍",
        quick_link: "快捷链接",
        impro_core: "价值观",
        impro_core_desc: "客户至上 诚信为本 创新为魂 言出必行 人尽其才 团结协作 ",
        impro_mission: "使命",
        impro_mission_desc: "建设领先的绿色环保汽车内饰产品创新工厂",
        impro_vision: "愿景",
        impro_vision_desc: "成为受人尊敬的行业标杆",
        title_customer: "主要客户",
        title_partners: "应用领域",
        title_prods_car: "汽车领域应用",
        title_prods_lists: "产品列表",
        title_prods_others: "其它领域应用",
        span_location: "您的位置",
        title_team: "专业团队",
        title_innovation: "技术创新",
        title_quality: "品质保证",
        title_news: "新闻中心",
        title_videos: "视频中心",
        title_product_detail: "产品详情",
        span_product_desc: "产品描述",
        span_car_neishi: "汽车内饰件原料",
        span_wechatP: "微信公众号",
        banner_home: "为创高端绿色汽车内饰而来",
        banner_home_txt1: "高端",
        banner_home_txt2: "环保",
        banner_home_txt3: "定制化",
        banner_about: "高端化、定制化汽车内饰材料生产",
        prod_header_txt1: "高端环保",
        prod_header_txt2: "科技时尚",
        prod01_name: "3Dmesh",
        prod01_feature: "抗黄化渣化，使用寿命高；阻燃系数高，使用更安全...",
        prod02_name: "pvc + 泡棉",
        prod02_feature: "高价值低成本装饰材料，皮革包覆件的理想替代品, 配以装饰线迹，内饰外观奢华, 与背泡搪塑表皮相比节约大约50%的材料重量...",
        prod03_name: "喷胶产品",
        prod03_feature: "热溶胶技术后道工序使用方便;价格优势，为后期加工节约大量人力物力...",
        prod04_name: "真皮 + 泡棉",
        prod04_feature: "独有的观感, 超豪华的触感; 良好加工柔韧性; 低排放，环保性能优越...",
        prod05_name: "包覆",
        prod07_name: "PET非织造无纺布材料",
        prod07_feature: "它以性能优异的PET非织造布为基体和骨架，通过与其他功能材料的巧妙结合，创造出能满足特定、苛刻应用需求的“超级材料”。",
        techno_header_txt1: "科技创新",
        techno_header_txt2: "倡导节能、环保、轻量化理念",
        techo_title_s: "创新是引领发展的第一动力",
        techno_txt1: "公司沉淀了一支知识结构搭配合理、分工明确、创新能力强的研发和服务团队。",
        techno_txt2: "现有研发人员60余人，专职博士、硕士20余人，本科及以上人员占比90%以上；",
        techno_txt3: "拥有一支业内资深专家组成的国际市场运营团队，使公司具备国际化的前瞻视野和丰富的项目运作经验。",
        techno_s_txt1: "研发人员，本科以上90%",
        techno_s_txt2: "资深国际市场运营团队",
        techno_s_txt3: "丰富的项目经验",
        techno_inno1_name: "技术专利",
        techno_inno1_txt: "授权发明专利 5 项",
        techno_inno2_name: "技术研究",
        techno_inno2_txt: "打造国家级材料工程技术研究中心",
        techno_inno3_name: "新产品销售",
        techno_inno3_txt: "新产品销售收入占总销售收入的80%以上",
        techno_inno4_name: "研发投入",
        techno_inno4_txt: "研发投入占营业收入的25%以上",
        techno_assc_txt1: "全面通过IATF16949:2016国际汽车行业质量管理体系认证",
        techno_assc_txt2: "15套柔性生产单元，快速满足客户定制化需求",
        techno_assc_txt3: "智能化的检测仪器，对从原材料到产成品全制程进行系统检测、分析",
        patents_title: "专利证书"
    },
    en: {
        companyName: "Jiangsu Misun Technology Co.,Ltd",
        companyName2: "Jiangsu Misun Advanced Composite Co.,Ltd",
        companyName_short: "Jiangsu Misun",
        companyDesc: "An emerging technology company specializing in the production of high-end green automotive interior materials, aiming to provide more environmentally friendly, more comfortable and higher quality interior materials for medium and high-end automobiles and new energy vehicles.",
        telephone: "24-hour Support Hotline",
        nav_home: "Home",
        nav_about: "About Us",
        nav_products: "Product & Solution",
        nav_technology: "Technological Innovation",
        nav_news: "News",
        nav_contact: "Contacts Us",
        lang_zh: "中文版",
        lang_en: "English",
        lang_ja: "日本語版",
        address: "Building 7, Phase 2, Xuzhang Innovation and Entrepreneurship Industrial Park, No. 232 Yongping Road, Medical Hi-tech Zone (Gaogang District), Taizhou City, Jiangsu Province.",
        advantage1: "Low odor and Low VOC",
        advantage1_desc: "We don`t need to burn the PU foam , so we don`t have any odour or excess VOC, and environment pollution issue due to burning PU foam.",
        advantage2: "Reducing the foam-yellowing  and foam- curling",
        advantage2_desc: "High temperature production-environment would have a devastating effect on the structure and properties of the foam, and the more common occurrence were the foam-yellowing and foam-curling. Glue coating，dueing to the low temperature production-environment, so we can significantly reduce the foam-yellowing. Furthermore, because of only 0.05 mm / ㎡ for the glue-surface thickness , the material can keeps soft and comfortable as original.",
        advantage3: "Don`t break surface of skin material",
        advantage3_desc: "We can control the temperature between 30℃-50℃ in lamination processing ,so it don`t break surface of skin material , and the adhesive is colorless , which will not influence color of skin material.",
        advantage4: "High-quality thickness control",
        advantage4_desc: "we coating the thickness is 0.03~0.05mm of adhesive without burning PU foam , so it don`t influence the thickness of final product",
        advantage5: "No more additional cost",
        advantage5_desc: "Adhesive cost is same with the cost of burn PU foam ,and we can control the volume of adhesive depending on the difference material ,meanwhile ,it can reach the peeling test request and controls cost .So our total cost is lower than flame.",
        advantage6: "More application",
        advantage6_desc: "we can lamination 3D mesh ,PP foam, textile and  real leather  that this style  material can not be burning , and high peeling request.",
        title_about: "About MISUN",
        about_desc1: "<strong>Jiangsu Misun</strong> is an emerging technology enterprise specializing in the production of high-end green automotive interior materials. We aim to provide more environmentally friendly, more comfortable and higher quality interior materials for middle and high grade cars and new energy vehicles.",
        about_desc2: "<strong>Jiangsu Misun</strong> use the world's leading environmentally compatible technology, the environmentally friendly polymer bonding technology is used to carry out low-temperature compounding of products, resulting in a composite product with higher environmental performance and better stability.",
        about_desc3: "<strong>Jiangsu Misun</strong> provide all directional customized business about lamination, cutting, sewing, adhesive precoating for leather，artificial leather, foamed materials and other automotive interior fabric.",
        about_desc4: "<strong>Jiangsu Misun</strong> passed the IATF16949:2016 international automotive industry quality management system certification, with higher quality management concept, more professional management team, more excellent equipment and production technology, to provide you with more satisfactory products and services.",
        product_feature_car: "<strong>MISUN</strong>use the world's leading environmentally friendly composite technology, using the environmentally friendly polymer bonding technology to carry out low temperature recombination of automotive interior products and abandon the traditional flame composite process. Bringing environmentally friendly, higher-end, more comfortable, eco-friendly lightweight automotive interior products.",
        product_feature_other: "<strong>MISUN</strong>adopts the world's leading environmentally friendly composite technology, using the environmentally friendly polymer bonding technology to carry out low-temperature compounding of products, bringing composite products with higher environmental performance and better stability.",
        btn_view_products: "View Products & Services",
        btn_view_more: "More Info",
        about_right_title1: "Senior international market operation team",
        about_right_txt1: "With an international market operation team composed of senior experts in the industry.",
        about_right_title2: "Global Marketing",
        about_right_txt2: "Our products are exported to Europe, the United States, Germany, Japan and other regions, and are in continuous expansion",
        about_right_title3: "High quality products, affordable",
        about_right_txt3: "High-end green products, continuous innovation, to provide customers with the highest quality products",
        title_advantages: "Our Advantages",
        title_products: "Products & Services",
        span_address: "Address",
        span_address2: "Company Address",
        span_mobile: "Mobile",
        span_email: "Email",
        span_campany: "Company Info",
        span_news_detail: "News Detail",
        nav_campany_news: "Company News",
        quick_link: "Quick Link",
        title_company_intro: "Company Introduction",
        impro_core: "Value",
        impro_core_desc: "Customer first, Integrity-based, innovation as the soul, Practice one's words, People do their best, Unite and cooperate",
        impro_mission: "Mission",
        impro_mission_desc: "Developing leading green automotive interior products innovative factory",
        impro_vision: "Vision",
        impro_vision_desc: "Becoming a respected industry benchmark",
        title_customer: "Major Clients",
        title_partners: "Application Field",
        title_prods_car: "Automotive applications",
        title_prods_lists: "Product Lists",
        title_prods_others: "Other field applications",
        span_location: "Your location",
        title_team: "Professional Team",
        title_innovation: "Technological Innovation",
        title_quality: "Quality Assurance",
        title_news: "News Lists",
        title_videos: "Videos Lists",
        title_product_detail: "Product Detail",
        span_product_desc: "product description",
        span_car_neishi: "Car interior parts",
        span_wechatP: "WeChat",
        banner_home: "Come for Guiding High-end Green Auto-interior",
        banner_home_txt1: "High-end",
        banner_home_txt2: "Green",
        banner_home_txt3: "Customization",
        banner_about: "High-end, customized automotive interior materials",
        prod_header_txt1: "High-end environmental protection",
        prod_header_txt2: "Technology fashion",
        prod01_name: "3Dmesh",
        prod01_feature: "Anti yellowing slag, High service life, high flame-retardant coefficient and safer using",
        prod02_name: "PVC + Foam",
        prod02_feature: "High-value, low-cost decorative materials, an ideal replacement for leather wraps, with decorative stitching, and a luxurious interior that saves approximately 50% of material weight compared to the back foamed plastic skin",
        prod03_name: "Product of glue spray ",
        prod03_feature: "The pur technology is easy to using after  process; the price advantage saves a lot of manpower and material for the later processing.",
        prod04_name: "Genuine Leather + Foam",
        prod04_feature: "Unique appearance, super luxurious touch, good processing flexibility, low emission and superior environmental protection performance.",
        prod05_name: "Cladding",
        prod07_name: "PET Non-Woven Fabric Material",
        prod07_feature: "Utilizing high-performance PET non-woven fabric as the base and skeleton, it is ingeniously combined with other functional materials to create a 'super material' capable of meeting specific and demanding application requirements.",
        techno_header_txt1: "Technological innovation",
        techno_header_txt2: "Advocate energy saving, environmental protection, lightweight concept",
        techo_title_s: "Innovation is the first driving force for development",
        techno_txt1: "Our company has a R & D and service team with reasonable knowledge structure, clear division of labor and strong innovation ability.",
        techno_txt2: "We have more than 60 R & D personnel, more than 20 full-time doctorate and master's degree, and 90% of undergraduate and above staff.",
        techno_txt3: "With an international market operation team composed of senior experts in the industry, the company has an international vision and rich experience in project operation.",
        techno_s_txt1: "R & D personnel, 90% above the bachelor degree",
        techno_s_txt2: "Senior international market operation team",
        techno_s_txt3: "Rich  experience of project",
        techno_inno1_name: "Technical patent",
        techno_inno1_txt: "Authorized invention patents 5 items",
        techno_inno2_name: "Technical research",
        techno_inno2_txt: "Creating a national Center for material engineering and technology research",
        techno_inno3_name: "Sales of new products",
        techno_inno3_txt: "New product sales account for more than 80% of total sales revenue",
        techno_inno4_name: "R&D investment",
        techno_inno4_txt: "R&D investment accounts for more than 25% of operating income",
        techno_assc_txt1: "Fully passed the IATF16949:2016 international automotive industry quality management system certification.",
        techno_assc_txt2: "15 sets of flexible production units to quickly meet customized needs of customers.",
        techno_assc_txt3: "The intelligent testing equipment, systematic testing and analysis of the whole process from raw materials to finished products",
        patents_title: "Patent Certificates"
    },
    ja: {
        companyName: "江蘇米山科学技術有限会社",
        companyName2: "江蘇米山複合材料有限会社",
        companyName_short: "江蘇米山",
        companyDesc: "わが社は専門的にハイエンド緑の自動車内装材料を生産する新興技術会社です。主に中高級車、新エネルギー車により環境にやさしくて、より快適で、より品質が高い内装材料を提供します。",
        telephone: "24時間サービスのホットライン",
        nav_home: "公式サイトホームページ",
        nav_about: "私たちについて",
        nav_products: "産品＆解決案",
        nav_technology: "技術革新",
        nav_news: "新聞センータ",
        nav_contact: "連絡方式",
        lang_zh: "中文版",
        lang_en: "English",
        lang_ja: "日本語版",
        address: "江苏省泰州市医药高新区（高港区）永平路232号许庄双創産業パーク二期7号工場",
        advantage1: "薄い匂い及び低いVOC",
        advantage1_desc: "私たちの複合技術はスポンジを燃える必要がないので、灼熱匂い及び余計なVOCを産生しません、そして、環境汚染という問題を出現する可能性も低くなります。",
        advantage2: "スポンジの黄化及び縮むことを減ります",
        advantage2_desc: "高温の生産雰囲気はスポンジの構造及び性質に破壊性の影響を与えます。よくスポンジ黄化及び材料の縮むという情況が起こります。ホッとメルトは低温の特性で顕著的にスポンジ黄化問題の産生を減られます。そして、ホットメルトの厚さはただ0.05ミリです、ほとんど材料本来の延性と展性を影響しません。材料本来の柔軟性及び快適さという特徴も保持られます。",
        advantage3: "よく材料のうわべを守る",
        advantage3_desc: "低温複合なので、複合するとき温度は30℃-50℃の間でうわべを傷けません。ホットメルトは透明色なので、うわべで色の汚染を作りません。",
        advantage4: "高品質的に厚さを控える",
        advantage4_desc: "複合する時、涂りパネルの厚さは0.03-0.05ミリです、スポンジを燃える必要がないので、よく複合製品の厚さを控えられます。",
        advantage5: "コストを増えない",
        advantage5_desc: "火と複合するとき、スポンジを燃えるのはスポンジにつけるホッとメルトです。私達も違う材料によって違う涂りパネルの量を控えます。剥離力の要求に達する同時に、コストも控えられます。だからこそ、私達はフレーム復合より低いコストが求められます。",
        advantage6: "より広い応用",
        advantage6_desc: "私達は3Dマッシュ、PPフォーム、織物、真皮など燃えられなくて複合強さに要求が高い材料を複合られます。",
        title_about: "米山について",
        about_desc1: "我が社は専門的にハイエンド緑の自動車内装材料を生産する新興技術会社です。主に中高級車、新エネルギー車により環境にやさしくて、より快適で、より品質が高い内装材料を提供します。",
        about_desc2: "我が社は世界先端の環境保護复合技術を採用して、も環境にやさしいポリマー接合技術を使用して製品の低温コンパウンドを実行し、より高い環境性能とより優れた安定性を持つ複合製品を生み出します。",
        about_desc3: "そして、我が社も真皮、人工皮革、発泡材料などの車内装材料の複合、裁断、裁縫、ゴムを塗ること、包装などのセットになるオーダーメイドの業務を提供します。",
        about_desc4: "同時IATF16949:2016国際自動車品質マネジメントシステム認証を取得、より高い質量管理理念、より専門的な管理チーム、より素晴らしい設備及び生産技術を使って貴様に満足させる産品及びサービスを提供します。",
        product_feature_car: "<strong>ミーシャンテクノロジー</strong>世界有数の環境にやさしい複合技術を採用し、も環境にやさしいポリマー接着技術を使用して、自動車内装製品の低温再結合を実行し、伝統的な火炎複合プロセスを放棄します。 環境にやさしい、ハイエンドの、より快適な、環境に優しい軽量の自動車用内装品をもたらす。",
        product_feature_other: "<strong>ミーシャンテクノロジー</strong>世界でも有数の環境にやさしい複合技術を採用し、も環境にやさしいポリマー接合技術を使用して製品の低温コンパウンドを実行し、より高い環境性能とより優れた安定性を持つ複合製品をもたらします。",
        about_right_title1: "ベテランな国際市場運営チーム",
        about_right_txt1: "業界でベテラン専門家からなる国際市場運営チームをもって、会社に国際的な視野及び豊富な項目運営経験を備えさせます",
        about_right_title2: "グローバルマーケティング",
        about_right_txt2: "製品は、ヨーロッパ、米国、ドイツ、日本およびその他の地域に輸出され、継続的に拡大しています",
        about_right_title3: "高品質の産品、買得だ",
        about_right_txt3: "ハイエンドな環境に優しい産品である、革新を続けて、お客様にも高品質の産品を提供します",
        btn_view_products: "製品をチェックする",
        btn_view_more: "引き続き目を通す",
        title_advantages: "私たちの優位",
        title_products: "製品＆サービス",
        span_address: "アドレス",
        span_address2: "会社アドレス",
        span_mobile: "連絡方式",
        span_email: "メール",
        span_campany: "会社情報",
        nav_campany_news: "会社新聞",
        title_company_intro: "会社紹介",
        quick_link: "ショ―トカットリンク",
        impro_core: "価値観",
        impro_core_desc: "お客様第一主義、有言実行、人の才能を尽くすのこと、団結協力、信用をもとにして、革新を魂にさせます",
        impro_mission: "使命",
        impro_mission_desc: "先端的な環境に優しい車内装産品を提供する革新工場になることを目指します",
        impro_vision: "会社ビジョン",
        impro_vision_desc: "人に尊敬される業界模範になります",
        title_customer: "メインお客様",
        title_partners: "適用分野",
        title_prods_car: "自動車用アプリケーション",
        title_prods_lists: "製品リスト",
        title_prods_others: "その他のフィールドアプリケーション",
        span_location: "あなたがいる場所",
        title_team: "専門的なチーム",
        title_innovation: "技術革新",
        title_quality: "品質保証",
        title_news: "新聞センータ",
        title_videos: "ビデオセンータ",
        title_product_detail: "製品の詳細",
        span_product_desc: "商品説明",
        span_car_neishi: "車内装部品",
        span_wechatP: "ウぃーチャット公式アカワンと",
        banner_home: "ハイエンドな緑の車の内装を作るためにきます",
        banner_home_txt1: "ハイエンド",
        banner_home_txt2: "環境にやさしい",
        banner_home_txt3: "オーダーメイド化",
        banner_about: "車の内装材料を素敵でオーダーメイドで生産します",
        prod_header_txt1: "ハイエンドで省エネ",
        prod_header_txt2: "科学技術ファッション",
        prod01_name: "3Dマッシュ",
        prod01_feature: "抗黄化できるので、使用期限が長い、燃えることも避けるので、使用もより安全です...",
        prod02_name: "pvc + スポンジ",
        prod02_feature: "価値が高くて、コストが低い内装材料、皮革の理想の代替品、内装も外観も贅沢で、前の材料と比べて５０％ぐらいの材料重さを節約できます...",
        prod03_name: "噴出製品",
        prod03_feature: "ホットメルト技術を使った後、仕上げ工程も便利になって、価格の優位で後の工程で相当的な人力及び物力を節約できます...",
        prod04_name: "真皮＋泡綿",
        prod04_feature: "特別な印象、すごく豪華的な触感、良い加工柔軟性、低排出、環境保護性能優越です...",
        prod05_name: "包む",
        prod07_name: "PET不織布材料",
        prod07_feature: "優れた性能を持つPET不織布を基材および骨格として、他の機能性材料と巧みに組み合わせることで、特定の過酷な使用環境における要求を満たす「スーパー材料」を創り出します。",
        techno_header_txt1: "科学技術革新",
        techno_header_txt2: "省エネ  環境に優しい   軽量化の理念を唱えます",
        techo_title_s: "イノベーションは開発の原動力です",
        techno_txt1: "我が社は知識構造の組み合わせが合理的で、職務の役割がはっきり明確で、革新能力が高い技術開発チーム及びサービスチームを持っています。",
        techno_txt2: "現在、技術開発人員は６０名あまりです。博士、大学院生は２０名あまりです。学部生及び学部生以上の人員は９０％以上を占めます;",
        techno_txt3: "業界でベテラン専門家からなる国際市場運営チームをもって、会社に国際的な視野及び豊富な項目運営経験を備えさせます;",
        techno_s_txt1: "９０％の技術開発人員は学部生です",
        techno_s_txt2: "ベテランの国際市場運営チームを持っています。",
        techno_s_txt3: "豊富な項目経験",
        techno_inno1_name: "技術意匠権",
        techno_inno1_txt: "権限を授けられる意匠権は 5 項です",
        techno_inno2_name: "技術研究",
        techno_inno2_txt: "創設国級材料工程技術研究センータ",
        techno_inno3_name: "新製品売上",
        techno_inno3_txt: "新製品売上金は総売上金の 80% を占めます",
        techno_inno4_name: "技術開発投入",
        techno_inno4_txt: "技術開発投入は営業投入の 25% を占めます",
        techno_assc_txt1: "IATF16949:2016国際自動車品質マネジメントシステム認証を取得",
        techno_assc_txt2: "１５個柔軟の生産単元をもって、速くお客様の注文を満足できます。",
        techno_assc_txt3: "一番インテリジェント化検測機器で原材料から産生品までの全過程を検測して分析します。",
        patents_title: "特許証明書"
    }
}

export default langs;